import React, { Component } from 'react';

//styles
import './middleSection.scss';

import '../../static/fonts/opensanshebrew/stylesheet.css'
import '../../static/fonts/NarkisBlockCondensed/style.css'
import galleryData from '../../data/galleryData.json'
import { GA_Event } from '../Analytics/Analytics'
import { scrollTo } from '../../static/scrollAnimation'
import {isMobile} from '../../static/helper'

class MiddleSection extends Component {
    constructor() {
        super();
        this.handleHover = this.handleHover.bind(this);
        this.handleLeave = this.handleLeave.bind(this);
        this.state = {
            hoverdIdx: 0,
            currentColor: "transparent",
            innerContainerPosition: 0
        }
    }

    handleHover(idx) {
        let color = "transparent";
        if (this.state.hoverdIdx > 0) {
            color = galleryData.filter(c => c.id == this.state.hoverdIdx)[0].color;
        }
        this.setState(prevState => ({
            hoverdIdx: idx,
            currentColor: color,
        }));
    }
    handleLeave() {
        this.setState({
            hoverdIdx: 0
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (isMobile()) {
            if (this.state.hoverdIdx > 0 && prevState.hoverdIdx != this.state.hoverdIdx) {
                setTimeout(() => {
                    let self = this.refs.active;
                    if (typeof self != "undefined") {
                        let offset = self.getBoundingClientRect();
                        let scroll = offset.top + window.scrollY;
                        scrollTo(self.offsetTop, Math.abs(scroll - 60), 1250)
                    }
                }, 800)
            }
        }
    }

    render() {
        let images = [];
        var color = "";
        for (let i = 0; i < galleryData.length; i++) {
            let divClass = this.state.hoverdIdx === galleryData[i].id ? "images image" + galleryData[i].id + " active" : this.state.hoverdIdx > 0 ? "images image" + galleryData[i].id + " not-active" : "images image" + galleryData[i].id;
            let ref = this.state.hoverdIdx === galleryData[i].id ? "active" : ""
            color = this.state.hoverdIdx === galleryData[i].id ? galleryData[i].color : "transparent"
            images.push(
                <div key={i} className={divClass} ref={ref} onMouseEnter={() => this.handleHover(galleryData[i].id)} onMouseLeave={this.handleLeave}>
                    <div className="line"></div>
                    <div className="small-line"></div>

                    <div className="title">{galleryData[i].title}</div>

                    <div className="name">{(galleryData[i].profit ? galleryData[i].profit + " " : "") + galleryData[i].firstName + " " + galleryData[i].lastName}</div>


                    <div className={this.state.hoverdIdx === galleryData[i].id ? "active-container" : "active-container hidden"}>
                        <div className="open-title">{galleryData[i].title}</div>
                        <div className="desc">{galleryData[i].desc}</div>
                        <button className="btn-go" onClick={
                            () => {
                                GA_Event('Button_Clicked', 'לסיפור של ' + galleryData[i].firstName);
                                window.location.href = `#/article/${galleryData[i].articleId}/${galleryData[i].commentId}`;
                            }
                        } >{"לסיפור של " + galleryData[i].firstName}</button>
                    </div>
                </div>
            );

        }
        return (
            <div className={this.state.hoverdIdx > 0 ? "section2-container open" : "section2-container"}>
                <div className="accordion-container" >
                    {images}
                </div>
            </div>
        );
    }
}

export default MiddleSection;


// WEBPACK FOOTER //
// ./src/Components/MiddleSection/MiddleSection.js